/**
 * Comprime y redimensiona una imagen antes de subirla.
 * Usa canvas para re-codificar a JPEG, reduciendo tamaño drásticamente
 * en dispositivos Android donde las fotos no se comprimen automáticamente.
 *
 * @param {File} file - Archivo de imagen del input
 * @param {{ maxSize?: number, quality?: number }} opts
 * @returns {Promise<string>} base64 data-URL lista para enviar al backend
 */
export function compressImage(file, { maxSize = 1200, quality = 0.8 } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)

    img.onload = () => {
      URL.revokeObjectURL(url)

      // On some Android devices the image object reports 0 dimensions even after onload
      if (!img.naturalWidth || !img.naturalHeight) {
        return reject(new Error('No se pudo leer la imagen'))
      }

      let { naturalWidth: width, naturalHeight: height } = img
      if (width > maxSize || height > maxSize) {
        if (width > height) {
          height = Math.round((height * maxSize) / width)
          width = maxSize
        } else {
          width = Math.round((width * maxSize) / height)
          height = maxSize
        }
      }

      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)

      const result = canvas.toDataURL('image/jpeg', quality)
      // 'data:,' means the canvas was empty (can happen in some Android WebViews)
      if (!result || result === 'data:,') {
        return reject(new Error('No se pudo procesar la imagen'))
      }

      resolve(result)
    }

    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('No se pudo leer la imagen'))
    }

    img.src = url
  })
}
